import React, { useEffect, useRef, useState } from 'react';
import './story.css';
import { useNavigate } from 'react-router-dom';

import Settings from '../components/common/settings';
import settingsSound from '../audios/settoings.wav';

const Story = () => {
  const navigate = useNavigate();

  const [openSettings, setOpenSettings] = useState(false);
  const [step, setStep] = useState(0);

  const settingsAudio = useRef(new Audio(settingsSound));

  const playSettingsSound = () => {
    settingsAudio.current.currentTime = 0;
    settingsAudio.current.play().catch(() => {});
  };

  const goToNextPage = () => {
    playSettingsSound();
    navigate('/roomload');
  };
  useEffect(() => {
    const timeline = [1, 2, 3, 4, 5, 6];
    let i = 0;

    const interval = setInterval(() => {
      setStep(timeline[i]);
      i++;

      if (i >= timeline.length) clearInterval(interval);
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="story">

      <div className="levelsnav">

        <button
          className="backbt"
          onClick={() => {
            playSettingsSound();
            navigate(-1);
          }}
        >
          BACK
        </button>

        <h1 className="mysteryhotel">MYSTERY HOTEL</h1>

        <div
          className="settings"
          onClick={() => {
            playSettingsSound();
            setOpenSettings(true);
          }}
        />
      </div>

      <div className="storymain">

        <div className="storydivv">
          <div className={`s11 story-item ${step >= 1 ? 'show' : ''}`} />
          <div className={`s22 story-item ${step >= 2 ? 'show' : ''}`} />
          <div className={`s33 story-item ${step >= 3 ? 'show' : ''}`} />
        </div>

        <div className="storydivv">
          <div className={`s4 story-item ${step >= 4 ? 'show' : ''}`} />
          <div className={`s5 story-item ${step >= 5 ? 'show' : ''}`} />
          <div className={`s6 story-item ${step >= 6 ? 'show' : ''}`} />
        </div>

      </div>

      <button
        className="nextbtt"
        onClick={goToNextPage}
      >
        NEXT
      </button>
      <Settings
        open={openSettings}
        onClose={() => {
          playSettingsSound();
          setOpenSettings(false);
        }}
        onPlaySound={playSettingsSound}
        onNavigate={navigate}
      />

    </section>
  );
};

export default Story;